/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meja_S4Inputs */

const en_tut_meja_s4 = /** @type {(inputs: Tut_Meja_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To talk, select the people you want (up to 12) and press **Buat panggilan dengan audiens terpilih**. If a call already exists, the button becomes **Buka rapat**.`)
};

const id_tut_meja_s4 = /** @type {(inputs: Tut_Meja_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk mengobrol, pilih rekan yang dituju (maksimal 12 orang) lalu tekan **Buat panggilan dengan audiens terpilih**. Kalau panggilan sudah ada, tombolnya menjadi **Buka rapat**.`)
};

/**
* | output |
* | --- |
* | "To talk, select the people you want (up to 12) and press **Buat panggilan dengan audiens terpilih**. If a call already exists, the button becomes **Buka rapa..." |
*
* @param {Tut_Meja_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meja_s4 = /** @type {((inputs?: Tut_Meja_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meja_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meja_s4(inputs)
	return en_tut_meja_s4(inputs)
});